import SolidGoogleColourIcon from 'LuxKit/Icons/solid/SolidGoogleColourIcon'
import Label from 'LuxKit/Label'
import { StyledSvgIcon, setSvgIconSize } from 'LuxKit/SvgIcon'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const GoogleIconBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${rem(16)};
  height: ${rem(16)};
  border-radius: ${props => props.theme.borderRadius.round};
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  margin-inline-end: ${rem(2)};

  > ${StyledSvgIcon} {
    ${setSvgIconSize(12)}
  }
`

function MetaSearchV2AsSeenOnGoogleLabel() {
  const intl = useIntl()

  return (
    <Label
      kind="primary"
      variant="highlight"
      startIcon={(
        <GoogleIconBadge>
          <SolidGoogleColourIcon />
        </GoogleIconBadge>
      )}
    >
      {intl.formatMessage({
        id: 'WnxSByUvWNcIgAUJBJCx',
        defaultMessage: 'As seen on Google',
      })}
    </Label>
  )
}

export default MetaSearchV2AsSeenOnGoogleLabel
